import axios from 'axios'

const https = axios.create({
  timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    'Content-Type': 'text/plain; charset=utf-8'
  }
})


export default https